import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { floor, decimalPlaces } from '../../utils/number'
import { setCurrentPrice } from '../../redux/exchange/action'
import zIndex from '../../utils/zIndexScale'

const Wrapper = styled.div`
  position: relative;
  z-index: ${zIndex.textContent};
  font-size: ${({ fontSize }) => fontSize};
  max-width: 140px;
  overflow: hidden;
`

const Value = styled.div`
  color: ${props => (props.isPositive ? props.theme.up : props.theme.down)};
  display: flex;
  justify-content: flex-start;
  transition: color 0.2s ease;
`

export const Postive = styled.div`
  color: ${({ theme }) => theme.up};
  display: flex;
  justify-content: flex-start;
`

export const Negative = styled.div`
  color: ${({ theme }) => theme.down};
  display: flex;
  justify-content: flex-start;
`

const Text = styled.div`
  color: ${props => props.color};
  display: flex;
  justify-content: ${props => props.align};
`

const NonValue = styled.div`
  justify-content: flex-start;
  text-indent: 40px;
`

class Price extends PureComponent {
  static propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    tickerSize: PropTypes.string,
    alignContent: PropTypes.string,
    priceColor: PropTypes.string,
    fontSize: PropTypes.string,
    onClick: PropTypes.func,
    noColorChange: PropTypes.bool,
    canSetPrice: PropTypes.bool,
    dispatch: PropTypes.func,
    format: PropTypes.func,
  }

  static defaultProps = {
    value: '-',
    tickerSize: '0.00000001',
    alignContent: 'flex-start',
    priceColor: '',
    fontSize: 'inherit',
    noColorChange: false,
    canSetPrice: false,
    onClick: () => {},
    dispatch: () => {},
    format: null,
  }

  _calValue = () => {
    const { value, tickerSize } = this.props
    let ts = 8
    if (tickerSize) {
      ts = decimalPlaces(tickerSize)
    }
    return floor(value, ts)
  }

  _clickPrice = () => {
    const { dispatch, canSetPrice, onClick } = this.props
    canSetPrice && dispatch(setCurrentPrice(this._calValue()))
    onClick && onClick(this._calValue())
  }

  _renderChange(value) {
    const { format, tickerSize } = this.props
    if (!value) return <NonValue>-</NonValue>
    if (value === '-') return <NonValue>-</NonValue>

    let displayValue = this._calValue()
    displayValue = format ? format(displayValue, decimalPlaces(tickerSize)) : displayValue

    const { noColorChange, priceColor } = this.props
    if (noColorChange) {
      return <div>{displayValue}</div>
    }

    if (priceColor) {
      const { alignContent } = this.props
      return (
        <Text color={priceColor} align={alignContent}>
          {displayValue}
        </Text>
      )
    }
    return <Value isPositive={value > 0}>{displayValue}</Value>
  }

  render() {
    const { value, fontSize } = this.props
    return (
      <Wrapper
        onClick={() => {
          this._clickPrice()
        }}
        fontSize={fontSize}
      >
        {this._renderChange(value)}
      </Wrapper>
    )
  }
}

const mapStateToProps = ({ exchange: { currentTrade }, tickers: { tickerSize } }) => ({
  tickerSize: decimalPlaces(tickerSize[currentTrade]) > 6 ? tickerSize[currentTrade] : '0.000001',
})

export default connect(mapStateToProps)(Price)
